// Mirrors labour_routes.job_price.
export const jobPrice = (j, seg) => {
  if (j.method === 'hours') {
    const h = j.hours?.[seg.key];
    return h && seg.hourly_rate ? h * seg.hourly_rate : null;
  }
  const p = j.prices?.[seg.key];
  return p === null || p === undefined || p === '' ? null : Number(p);
};
